import './polyfill';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import configureStore from './store';
import MainApp from './MainApp';
import * as serviceWorker from './serviceWorker';

const rootEl = document.getElementById('app-site');
export const store = configureStore();

const AppWithUpdatePrompt = () => {
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [pendingRegistration, setPendingRegistration] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    const checkForServiceWorkerUpdate = () => {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistration().then(registration => {
          if (registration) {
            registration.update().catch(() => {});
          }
        });
      }
    };

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        checkForServiceWorkerUpdate();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    serviceWorker.register({
      onUpdate: registration => {
        setPendingRegistration(registration);
        setShowUpdateModal(true);
      }
    });

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  const handleConfirmUpdate = () => {
    setShowUpdateModal(false);
    setIsUpdating(true);

    if (pendingRegistration && pendingRegistration.waiting) {
      pendingRegistration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }

    if ('serviceWorker' in navigator && pendingRegistration && pendingRegistration.waiting) {
      let fallbackReloadTimer;

      const onControllerChange = () => {
        if (fallbackReloadTimer) {
          clearTimeout(fallbackReloadTimer);
        }

        navigator.serviceWorker.removeEventListener(
          'controllerchange',
          onControllerChange
        );

        setIsUpdating(false);
        window.location.reload();
      };

      fallbackReloadTimer = window.setTimeout(() => {
        navigator.serviceWorker.removeEventListener(
          'controllerchange',
          onControllerChange
        );

        setIsUpdating(false);
        window.location.reload();
      }, 5000);

      navigator.serviceWorker.addEventListener(
        'controllerchange',
        onControllerChange
      );

      return;
    }

    setIsUpdating(false);
    window.location.reload();
  };

  return (
    <Provider store={store}>
      <MainApp />

      <SweetAlert
        show={showUpdateModal}
        title="Nova versão disponível"
        showCancel
        confirmBtnText="Atualizar agora"
        cancelBtnText="Depois"
        onConfirm={handleConfirmUpdate}
        onCancel={() => setShowUpdateModal(false)}
      >
        A aplicação foi atualizada. Deseja recarregar agora para usar a versão mais recente?
      </SweetAlert>

      <Backdrop style={{ zIndex: '99999' }} open={isUpdating}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Provider>
  );
};

ReactDOM.render(
  <AppWithUpdatePrompt />,
  rootEl
);